export default __webpack_public_path__ + "static/media/google-icon.d752f318.png";